import { lazy } from 'react';
export var ProfileCardLazy = /*#__PURE__*/lazy(function () {
  return import( /* webpackChunkName: "@atlaskit-internal_lazy-profilecard" */
  './ProfileCard');
});